import { push as _push } from 'FormsUI/actions/HistoryActions';
import { getQueryParams } from 'FormsUI/utils/QueryParams';
import getQueryParamsFromObject from 'forms-utils-lib/urls/queryParams/getQueryParamsFromObject';
import { SORTING_COLUMN, SORT_DIRECTION } from 'FormsUI/constants/QueryParams';
export const ROUTER_ACTION = '@@router/LOCATION_CHANGE';
export function updateParams(params, resetParams = false) {
  return dispatch => {
    const oldQueryParams = getQueryParams();
    const queryObject = resetParams ? params : Object.assign(oldQueryParams, params);
    dispatch(_push(`${window.location.pathname}${getQueryParamsFromObject(queryObject)}`));
  };
}
export const removeQueryParams = params => dispatch => {
  const paramsObj = params.reduce((obj, param) => Object.assign({}, obj, {
    [param]: undefined
  }), {});
  dispatch(updateParams(paramsObj));
};
export function updateRouteAndAddParams(pathname, query) {
  return dispatch => {
    dispatch(_push(`${pathname}${window.location.search ? '' : '?'}${new URLSearchParams(query).toString()}`));
  };
}
export const removeSortingParams = () => dispatch => {
  dispatch(removeQueryParams([SORTING_COLUMN, SORT_DIRECTION]));
};